import React from 'react';

export const FontStyleUnderline = () => (
    <g>
        <path d='M23.5,23h-23C0.224,23,0,23.224,0,23.5S0.224,24,0.5,24h23c0.276,0,0.5-0.224,0.5-0.5S23.776,23,23.5,23z' />
        <path d='M1.5,1H4v11c0,4.411,3.589,8,8,8s8-3.589,8-8V1h2.5C22.776,1,23,0.776,23,0.5S22.776,0,22.5,0h-6
			C16.224,0,16,0.224,16,0.5S16.224,1,16.5,1H19v11c0,3.859-3.141,7-7,7s-7-3.141-7-7V1h2.5C7.776,1,8,0.776,8,0.5S7.776,0,7.5,0h-6
			C1.224,0,1,0.224,1,0.5S1.224,1,1.5,1z' />
    </g>
);